import React from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
	label?: string;
	help?: string;
	error?: string;
};

export function Input({
	label,
	help,
	error,
	className = "",
	id,
	...props
}: Props) {
	const generatedId = React.useId();
	const inputId = id ?? generatedId;
	return (
		<div className="space-y-1.5">
			{label ? (
				<label className="label" htmlFor={inputId}>
					{label}
				</label>
			) : null}
			<input
				id={inputId}
				className={`input ${
					error ? "border-[var(--color-danger)]" : ""
				} ${className}`}
				{...props}
			/>
			{help ? <p className="help">{help}</p> : null}
			{error ? (
				<p
					className="help"
					role="alert"
					style={{ color: "var(--danger)" }}
				>
					{error}
				</p>
			) : null}
		</div>
	);
}
